/**
 * Calculate total points from selected answers
 *
 * @param {Object} answers
 * Structure:
 * {
 *   [questionId]: {
 *     id: number,
 *     answer: string,
 *     score: number
 *   }
 * }
 *
 * @returns {number} total points
 */
export function calculateTotalPoints(answers) {
  // Safety check
  if (!answers || typeof answers !== "object") {
    return 0;
  }

  // Sum all selected answer scores
  return Object.values(answers).reduce((total, answer) => {
    // answer?.score protects against undefined
    return total + (answer?.score || 0);
  }, 0);
}
